/** Иконка категории в кружке её цвета — стиль C из бренд-бука.
 *
 * Размер задаётся контекстом: 40 в строке списка, 34 в компактной, 32 в
 * настройках. Глиф всегда одна и та же доля кружка — иначе набор рассыпается.
 *
 * ПОЧЕМУ 56%, А НЕ 45%. При 45% в кружке на 34 пикселя глиф выходил 15 — а
 * рисунок тогда занимал лишь две трети своего квадрата, и на экране оставалась
 * точка в пустом круге. Набор перерисован от края до края (`categoryIcon.ts`),
 * и доля поднята под него. Выше 60% рисунок упирается в край кружка.
 */
import { categoryPaths } from "../lib/categoryIcon.ts";

export function CategoryIcon({ name, color, size = 40, icon }: {
  name: string;
  color: string;
  size?: number;
  /** Ключ значка, выбранный человеком. Не задан — подбираем по названию. */
  icon?: string | null;
}) {
  const glyph = Math.round(size * 0.56);
  return (
    <span
      aria-hidden="true"
      style={{
        width: size, height: size, borderRadius: "50%", flexShrink: 0,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: `color-mix(in srgb, ${color} 16%, transparent)`,
      }}
    >
      <svg width={glyph} height={glyph} viewBox="0 0 24 24" fill="none" stroke={color}
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {categoryPaths(name, icon).map((d) => <path key={d} d={d} />)}
      </svg>
    </span>
  );
}
